<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M2,12C0.9,12,0,12.9,0,14C0,15.1,0.9,16,2,16C3.1,16,4,15.1,4,14C4,12.9,3.1,12,2,12C2,12,2,12,2,12ZM2,6C0.9,6,0,6.9,0,8C0,9.1,0.9,10,2,10C3.1,10,4,9.1,4,8C4,6.9,3.1,6,2,6C2,6,2,6,2,6ZM2,0C0.9,0,0,0.9,0,2C0,3.1,0.9,4,2,4C3.1,4,4,3.1,4,2C4,0.9,3.1,0,2,0C2,0,2,0,2,0ZM14,4C15.1,4,16,3.1,16,2C16,0.9,15.1,0,14,0C12.9,0,12,0.9,12,2C12,3.1,12.9,4,14,4C14,4,14,4,14,4ZM14,6C12.9,6,12,6.9,12,8C12,9.1,12.9,10,14,10C15.1,10,16,9.1,16,8C16,6.9,15.1,6,14,6C14,6,14,6,14,6ZM8,0C6.9,0,6,0.9,6,2C6,3.1,6.9,4,8,4C9.1,4,10,3.1,10,2C10,0.9,9.1,0,8,0C8,0,8,0,8,0ZM14,12C12.9,12,12,12.9,12,14C12,15.1,12.9,16,14,16C15.1,16,16,15.1,16,14C16,12.9,15.1,12,14,12C14,12,14,12,14,12ZM8,6C6.9,6,6,6.9,6,8C6,9.1,6.9,10,8,10C9.1,10,10,9.1,10,8C10,6.9,9.1,6,8,6C8,6,8,6,8,6ZM8,12C6.9,12,6,12.9,6,14C6,15.1,6.9,16,8,16C9.1,16,10,15.1,10,14C10,12.9,9.1,12,8,12C8,12,8,12,8,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LayoutGrid',
} as DefineComponent
</script>
